import React from 'react';

const StatusItem = ({status}) => {
    if (status === true) {
        return (
            <span className="text-bold text-success">
                <i className="fa fa-fw fa-check"></i> {window.__js_bid_reviews.reviewed}
            </span>
        );
    }

    if (status === false) {
        return (
            <span className="text-bold text-warning">
                <i className="fa fa-fw fa-question-circle"></i> {window.__js_bid_reviews.review_pending}
            </span>
        );
    }

    return '-';
}

const TableRow = ({data}) => {
    return (
        <tr>
            <td>{data.assessor.name}</td>
            <td><StatusItem status={data.stages.stage1.is_assessed}/></td>
            <td><StatusItem status={data.stages.stage2.is_assessed}/></td>
            <td><StatusItem status={data.stages.stage3.is_assessed}/></td>
        </tr>
    );
}

export default TableRow;